import { render, staticRenderFns } from "./PrintPupilsQrCodes.vue?vue&type=template&id=7c5a5f18&scoped=true&"
import script from "./PrintPupilsQrCodes.vue?vue&type=script&lang=ts&"
export * from "./PrintPupilsQrCodes.vue?vue&type=script&lang=ts&"
import style0 from "./PrintPupilsQrCodes.vue?vue&type=style&index=0&id=7c5a5f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a5f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VSheet,VSpacer,VToolbar,VToolbarTitle})
